import { inputBaseClasses } from "@mui/material/InputBase";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { getInputFocusRingStyles } from "./input-focus-ring";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiOutlinedInput = {
	defaultProps: { notched: false },
	styleOverrides: {
		root: {
			...getInputFocusRingStyles(
				`&.${outlinedInputClasses.error}`,
				`&.${outlinedInputClasses.disabled}`
			),
		},
		input: {
			height: "auto",
			padding: 0,
			[`label[data-shrink=false]+.${inputBaseClasses.formControl} &`]: {
				"&::placeholder": { opacity: "1 !important" },
			},
			// Remove number input spinners
			"&[type=number]": {
				MozAppearance: "textfield", // Firefox
				"&::-webkit-outer-spin-button": {
					WebkitAppearance: "none",
					margin: 0,
				},
				"&::-webkit-inner-spin-button": {
					WebkitAppearance: "none",
					margin: 0,
				},
			},
		},
		notchedOutline: { display: "none" },
	},
} satisfies Components<Theme>["MuiOutlinedInput"];
